import { Table } from "@tblabs/truffle/Controls/TableBuilder/Table";
import { TimeUtils } from "../../../Utils/TimeUtils";
import { PaymentFormNames } from "../../../Models/Payment/PaymentForm";
import { PaymentStepData } from "../Models/PaymentStepData";
import { PaymentForm } from "../../../Models/Payment/PaymentForm";
import { Human } from "../../../Models/Human";
import { TextFormatter } from "../../../Utils/TextFormatter";


export class PaymentReturnInfoForCustomer extends Table
{
    constructor(payment: PaymentStepData, customer?: Human)
    {
        super();
        this.Class("payment-info-table");

        if (payment.Form.Is(PaymentForm.Unset))
        {
            this.AddRow("Forma", "⚠️ Forma zwrotu nie została określona");
            return;
        }

        this.AddRow("Forma", PaymentFormNames[payment.Form.value])
            .AddRow("Kwota", payment.AmountAsString)
            .AddRow("Tytułem", payment.Title.value)

        let accountNumber = payment.AccountNumber.value || customer?.BankAccountNumber?.value;

        switch (payment.Form.value)
        {
            case PaymentForm.Cash:
                break;

            case PaymentForm.Blik:
                this.AddRow("Na numer", this.HidePhoneNumber(TextFormatter.NicePhoneNumber(accountNumber ||customer?.Phone?.value || "")) || "⚠️ brak numeru telefonu");
                break;

            case PaymentForm.Crypto:
                const toPay = (payment.Amount.value / payment.ExchangeRate.value).toFixed(8);
                this.AddRow("Wartość", "Wyliczona z proporcji")
                    .AddRow("Z kwoty", payment.AmountAsString)
                    .AddRow("Do zwrotu", toPay + " " + payment.PaymentCurrency.value)
                    .AddRow("Kurs", `Z momentu wpłaty:\n${payment.ExchangeRate.value} PLN za 1 BTC`)
                    .AddRow("Portfel", accountNumber ? this.HideCryptoNumber(accountNumber) : "⚠️ brak adresu portfela");
                break;

            case PaymentForm.BankTransfer:
                if (!accountNumber && payment.Form.Is(PaymentForm.BankTransfer))
                {
                    this.AddRow("Konto", "Zwrot na to samo konto");
                }
                else 
                {
                    this.AddRow("Konto", accountNumber ? this.HideAccountNumber(accountNumber) : "⚠️ brak numeru konta");
                }
                break;

            case PaymentForm.PostalTransfer:
                this.AddRow("Konto", accountNumber ? this.HideAccountNumber(accountNumber) : "⚠️ brak numeru konta");
                break;

            default:
                break;
        }

        this.AddRow("Termin", "do " + TimeUtils.FormattedDate(payment.Deadline.value));

        if (payment.Comment.value)
            this.AddRow("Komentarz", payment.Comment.value);
    }

    private HidePhoneNumber(number?: string): string
    {
        if (!number) return "";

        const first = number.slice(0, 1);
        const last = number.slice(-2);

        return first + "** *** *" + last;
    }

    private HideCryptoNumber(number?: string): string
    {
        if (!number) return "";

        const first = number.slice(0, 6);
        const last = number.slice(-8);

        return first + "....." + last;
    }

    private HideAccountNumber(number?: string): string
    {
        if (!number) return "";

        const first2 = number.slice(0, 2);
        const last4 = number.slice(-4);

        return first2 + " **** **** **** **** **** " + last4;
    }
}
